import { Button, Card, CardContent, Grid, Container, Stepper, Step, StepLabel, Typography } from '@mui/material'
import { ArrowLeft, ArrowLeftCircle, Save } from 'react-feather'

import { AdminFormStepApplies } from './StepApplies/AdminFormStepApplies'
import { AdminFormStepApproval } from './StepApproval/AdminFormStepApproval'
import { AdminFormStepDeposit} from './StepDeposit/AdminFormStepDeposit'
import { AdminFormStepFiles } from './StepFiles/AdminFormStepFiles'
import { ObservationLog } from './ObservationLog'

// Array que define cuantos pasos va a tener
const steps = ['Info. Solicitud', 'Documentos Adjuntos', 'Depositos', 'Info. Aprobación']

const AdminAppliesForm = ({useFetchInit}) => {
    
    const {
        globalStates,
        Forms,
        Actions
    } = useFetchInit

    const { FormLeases } = Forms
    const { formState } = FormLeases

    const { stepApplilication } = globalStates

    const { handleClickCompleteRequest, handleClickHideForm, handleClickReturnStep } = Actions

    // Para definir que va a renderizar en cada paso
    const getStepContent = (stepApplilication) => {
        switch (stepApplilication) {
            case 0:
                return <AdminFormStepApplies 
                    useFetchInit = {useFetchInit}
                />
            case 1:
                return <AdminFormStepFiles 
                    useFetchInit = {useFetchInit}
                />;
            case 2:
                return <AdminFormStepDeposit
                    useFetchInit = {useFetchInit}
                />;
            case 3:
                return <AdminFormStepApproval
                    useFetchInit = {useFetchInit}
                />;
            default:
                throw new Error('Unknown step');
        }
    }

    return (
        <div className="content">
            <div className='panel-body'>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Card style={{zIndex:'1'}}>
                            <CardContent>
                                <Button
                                    startIcon={<ArrowLeft/>}
                                    variant='text'
                                    color='error'
                                    size='large'
                                    sx={{ marginTop: 2, marginBottom : 2 }}
                                    onClick={handleClickHideForm}
                                >
                                    Volver a la pantalla anterior
                                </Button>
                                <div className="border-bottom border-dark"></div>

                                <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
                                    <Stepper activeStep={stepApplilication} sx={{ pt: 3, pb: 5 }}>
                                        {steps.map((label) => (
                                            <Step key={label}>
                                                <StepLabel>{label}</StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>
                                </Container>
                                
                                <p className='text-danger'>* campos obligatorios</p>
                                {stepApplilication === steps.length ? (
                                    <div className='text-center'>
                                    <Typography variant="h5" gutterBottom>
                                        Confirmación de procedimiento.
                                    </Typography>
                                    <p> 
                                        Todos los pasos se han cumplido, 
                                        haga click en el botón de "Finalizar procedimiento" para volver a la pantalla de solicitudes,
                                        o "Volver a revisar" para volver a al paso anterior
                                    </p>
                                    <div className="border-bottom border-secondary m-3"></div>
                                    <div className="text-center">
                                    <Button 
                                        startIcon={<ArrowLeftCircle/>}
                                        variant="contained"
                                        type="button" 
                                        className='btn-round'
                                        color='warning'
                                        onClick={handleClickReturnStep} 
                                        sx={{ marginRight: 1, marginLeft: 1 }}
                                    >
                                        Volver
                                    </Button>
                                    <Button
                                        endIcon={<Save/>}
                                        variant="contained"
                                        className='btn-round'
                                        color='primary'
                                        type='button'
                                        sx={{ marginRight: 1, marginLeft: 1 }}
                                        onClick={handleClickCompleteRequest}
                                    >
                                        Finalizar procedimiento
                                    </Button>
                                    </div>
                                </div>

                            ) : (
                                <>
                                    {getStepContent(stepApplilication)}
                                    {(formState.idcontrato>0)&&(
                                        <ObservationLog useFetchInit={useFetchInit}></ObservationLog>
                                    )}
                                </>
                            )}
                            </CardContent>
                        </Card>
                    </Grid> 
                </Grid> 
            </div>
        </div>
    )
    
}

export {
    AdminAppliesForm
}